import { IHttpApi } from '@cian/http-api';
import {
  IMessagesOfferRequest,
  IMessagesOfferResponse,
  IMessagesOfferResponseError,
  fetchMessagesOffer,
} from '../../repositories/chats/v1/messages-offer';

export async function sendFirstMessage(
  httpApi: IHttpApi,
  parameters: IMessagesOfferRequest,
): Promise<IMessagesOfferResponse> {
  const { response, statusCode } = await fetchMessagesOffer({ httpApi, parameters });

  if (statusCode !== 200) {
    throw new Error((response as IMessagesOfferResponseError).message);
  }

  return response as IMessagesOfferResponse;
}
